import React from 'react';
import { useActions } from '../../hooks/useStore';
import AddManualCombatantModal from './AddManualCombatantModal';
import type { Combatant } from '../../types/types';

interface AddManualCombatantModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Container for AddManualCombatantModal (ADR-034).
 * Owns store access for the addCombatant action.
 */
const AddManualCombatantModalContainer: React.FC<AddManualCombatantModalContainerProps> = ({
  isOpen,
  onClose,
}) => {
  const actions = useActions();

  const handleAddCombatant = (combatant: Omit<Combatant, 'id'> & { id?: number }) => {
    actions.addCombatant(combatant);
  };

  return (
    <AddManualCombatantModal
      isOpen={isOpen}
      onClose={onClose}
      onAddCombatant={handleAddCombatant}
    />
  );
};

export default AddManualCombatantModalContainer;
